import React from 'react';
import { STATUS_LEVELS } from '../utils/siteStatus';

/** The site-health colour as a small dot; decorative, the text beside it carries the meaning. */
const StatusDot = ({ level, size = 8, style }) => (
    <span
        aria-hidden='true'
        style={{
            display: 'inline-block',
            width: size,
            height: size,
            borderRadius: '50%',
            flexShrink: 0,
            backgroundColor: (STATUS_LEVELS[level] || STATUS_LEVELS.down).color,
            ...style
        }}
    />
);

export default StatusDot;
